import React from 'react';

import { FormattedCoachingVisit } from 'src/models/Sessions';

import PsychiatryVisitType from './PsychiatryVisitType/PsychiatryVisitType';
import VisitTypeChip from './VisitTypeChip/VisitTypeChip';

type Props = {
  showHpiClientStatusInfo: boolean;
  providerIsPsychiatrist: boolean;
  visit: FormattedCoachingVisit;
};

const SessionType: React.FC<Props> = ({
  showHpiClientStatusInfo,
  providerIsPsychiatrist,
  visit,
}) => {
  if (providerIsPsychiatrist)
    return <PsychiatryVisitType isInitialEvaluation={visit.isPsychiatryInitialEvaluation} />;

  if (showHpiClientStatusInfo) return <VisitTypeChip visitType={visit.visitType} />;

  return null;
};

export default SessionType;
